import _ from 'underscore';
const TypesCheck = {
    isEmpty:_.isEmpty,
    isElement:_.isElement,
    isArray:_.isArray,
    isObject:_.isObject,
    isArguments:_.isArguments,
    isFunction:_.isFunction,
    isString:_.isString,
    isNumber:_.isNumber,
    isFinite:_.isFinite,
    isBoolean:_.isBoolean,
    isDate:_.isDate,
    isRegExp:_.isRegExp,
    isError:_.isError,
    isNaN:_.isNaN,
    isNull:_.isNull,
    isUndefined:_.isUndefined
};
export default TypesCheck;